/**
 * Depends Value
 *
 * Hide depending inputs until the parent input has ANY value
 * (will show all inputs if javascript is off)
 * 
 * Usage example:
 * Prevent newsletter form spam by 
 * making email the required parent input
 * and showing a sum as soon as someone fills in email.
 * 
 * @since 1.0.0
 */

const DependsValue = () => {
  const containers = document.querySelectorAll('.js-depends-value')
  if (containers.length < 1) return

  ;[...containers].forEach(container => {

    const input_name = container.dataset.name
    const form = container.closest('.js-form')
    const leader_input = form.querySelector('input[name="'+ input_name +'"]')

    // hide on first load
    hideDependers(container)

    // return early if leader_input isn't required
    if (! leader_input.required) return

    // show hidden inputs if leader_input gets ANY value
    leader_input.addEventListener('input', () => {
      if (leader_input.value != '') {
        showDependers(container)
      } else {
        hideDependers(container)
      }
    })

  }) // end foreach

}

function hideDependers(container) {
  container.classList.add('inactive')
}

function showDependers(container) {
  container.classList.remove('inactive')
}

export default DependsValue


// WEBPACK FOOTER //
// ./src/js/modules/DependsValue.js